import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import PhoneVerification from './components/Auth/PhoneVerification';
import AdminLogin from './components/Auth/AdminLogin';
import Dashboard from './pages/Dashboard';
import Markets from './pages/Markets';
import Deposit from './pages/Deposit';
import Withdraw from './pages/Withdraw';
import KYCUpload from './pages/KYCUpload';
import TradeHistory from './pages/TradeHistory';
import AdminDashboard from './pages/AdminPanel/AdminDashboard';
import KYCReview from './pages/AdminPanel/KYCReview';
import WithdrawalApproval from './pages/AdminPanel/WithdrawalApproval';
import TradeEntry from './pages/AdminPanel/TradeEntry';
import UserManagement from './pages/AdminPanel/UserManagement';
import Layout from './components/Layout/Layout';
import AdminLayout from './components/Layout/AdminLayout';
import TransactionHistory from './pages/TransactionHistory';
import Profile from './pages/Profile';
import UserTrading from './components/Trading/UserTrading';
import AdvancedAnalytics from './pages/AdminPanel/AdvancedAnalytics';
import Trading from './pages/Trading';
import SignalManager from './pages/AdminPanel/SignalManager';
// REMOVED: import Footer from './components/Layout/Footer';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

const LoadingScreen = () => (
  <div className="flex items-center justify-center min-h-screen bg-[#0f172a]">
    <div className="text-center">
      <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-gray-400">Loading...</p>
    </div>
  </div>
);

function AppContent() {
  const { user, loading } = useAuth();
  const isAdminLoggedIn = sessionStorage.getItem('admin') !== null;
  
  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-phone" element={<PhoneVerification />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      
      <Route path="/" element={user ? <Layout /> : <Navigate to="/login" replace />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="markets" element={<Markets />} />
        <Route path="deposit" element={<Deposit />} />
        <Route path="withdraw" element={<Withdraw />} />
        <Route path="kyc" element={<KYCUpload />} />
        <Route path="trades" element={<TradeHistory />} />
        <Route path="history" element={<TransactionHistory />} />
        <Route path="profile" element={<Profile />} />
        <Route path="mytrades" element={<UserTrading />} />
        <Route path="trading" element={<Trading />} />
        <Route path="signals" element={<SignalManager />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Route>
      
      {(isAdminLoggedIn || user?.role === 'admin' || user?.role === 'super_admin') && (
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="kyc-review" element={<KYCReview />} />
          <Route path="withdrawals" element={<WithdrawalApproval />} />
          <Route path="trades" element={<TradeEntry />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="analytics" element={<AdvancedAnalytics />} />
        </Route>
      )}
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;